













import { Component, Vue } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';

import PerformanceTransactionsList from '@/componentsV2/templates/PerformanceTransactionList/PerformanceTransactionsList.vue';

@Component({
  components: {
    Page,
    PerformanceTransactionsList
  }
})
export default class TransactionsCenter extends Vue {
  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }
}
